import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/** @jsx $jsx */
import { $jsx } from 'framework7';
import $ from 'dom7';
import Base from '../js/base.js';
import Utils from '../js/utils.js';
import moment from 'moment';
import Employee from '../js/employee.js';
import AutoNumeric from 'autonumeric';
var EmployeeList = {
  pn: 'div[data-name=employee]',
  page: 0,
  limit: 50,
  currentDisplay: 0,
  allowInfinite: true,
  hasMoreItems: true,
  totalItems: 0,
  $f7: null,
  init: function init($in_f7) {
    var self = this;
    self.$f7 = $in_f7;
    self.page = 0;
    self.currentDisplay = 0;
    self.allowInfinite = true;
    self.hasMoreItems = true;
    self.list();
    $(self.pn + ' .infinite-scroll-content').on('infinite', function () {
      if (!self.allowInfinite) return;
      self.allowInfinite = false;
      self.page += 1;
      self.list();
    });
    $('.open-employee-form').click(function (e) {
      Base.app.popup.create({
        content: $('#employee-form-popup-wrapper').html(),
        animate: false,
        on: {
          open: function open(popup) {
            AutoNumeric.multiple('.salary-autonumeric', Base.autoNumericConfig); //Create new

            $(popup.el).find('.save-employee-button').click( /*#__PURE__*/function () {
              var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
                var data, rs;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        data = Base.app.form.convertToData($(popup.el).find('.list')); //Remove autonumeric

                        data.salary = Utils.str2Num(data.salary);

                        if (!(data.phone.length === 0 || data.phone.length < 10)) {
                          _context.next = 5;
                          break;
                        }

                        Base.app.notification.create({
                          text: 'Số điện thoại không đủ 10 số',
                          closeOnClick: true,
                          closeTimeout: 3000
                        }).open();
                        return _context.abrupt("return", false);

                      case 5:
                        if (!(data.name.length === 0)) {
                          _context.next = 8;
                          break;
                        }

                        Base.app.notification.create({
                          text: 'Chưa có tên nhân viên',
                          closeOnClick: true,
                          closeTimeout: 3000
                        }).open();
                        return _context.abrupt("return", false);

                      case 8:
                        _context.next = 10;
                        return Base.api('Employee', 'save', data);

                      case 10:
                        rs = _context.sent;
                        Base.app.notification.create({
                          text: rs.message,
                          closeOnClick: true,
                          closeTimeout: 3000
                        }).open();
                        if (rs.result === 'add-success') $(self.pn + ' .employee-list').append(self.appendRow(rs.row)); //Refresh lại danh sách nhân viên

                        _context.next = 15;
                        return Employee.list()['rows'];

                      case 15:
                        Employee.rows = _context.sent;
                        popup.close();

                      case 17:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function (_x) {
                return _ref.apply(this, arguments);
              };
            }());
          }
        }
      }).open();
    });
  },
  appendRow: function appendRow(item) {
    var $row = $("\n      <li>\n        <div class=\"padding\" style=\"display:flex; border-bottom: 1px solid rgb(80, 80, 80);\">\n          <div style=\"color: orange; width: 50%\" class=\"name\">".concat(item.name, "</div>\n          <div style=\"flex-grow: 1\" class=\"phone\">").concat(item.phone, "</div> \n          <div style=\"flex-grow: 1; text-align: right;\" class=\"text-color-orange\"><i class=\"f7-icons icon remove\" style=\"font-size: 16px;\">multiply_square_fill</i></div>\n        </div>\n      </li>\n    "));
    $row.data('row', item);
    $row.find('.remove').click(function (e) {
      Base.app.dialog.confirm('Xác nhận cho nghỉ?', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var loader;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                loader = Base.app.dialog.preloader();
                _context2.next = 3;
                return Base.api('Employee', 'remove', {
                  id: item.id
                });

              case 3:
                _context2.next = 5;
                return Employee.list()['rows'];

              case 5:
                Employee.rows = _context2.sent;
                loader.close();
                $row.remove();

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      })));
    });
    $row.find('.name').click(function (e) {
      Base.app.popup.create({
        content: $('#employee-form-popup-wrapper').html(),
        animate: false,
        on: {
          open: function open(popup) {
            var data = $row.data('row');
            $(popup.el).find('.reset-employee-password-button').removeClass('display-none');
            $(popup.el).find('.reset-employee-password-button').click( /*#__PURE__*/function () {
              var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(e) {
                var rs;
                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        _context3.next = 2;
                        return Base.api('Employee', 'updatePassword', {
                          id: data.id
                        });

                      case 2:
                        rs = _context3.sent;
                        Base.app.notification.create({
                          text: 'Khôi phục mật khẩu thành công',
                          closeOnClick: true,
                          closeTimeout: 1500
                        }).open();
                        popup.close();

                      case 5:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3);
              }));

              return function (_x2) {
                return _ref3.apply(this, arguments);
              };
            }());
            data.salary = data.salary || 0;
            AutoNumeric.multiple('.salary-autonumeric', Base.autoNumericConfig);
            Base.app.form.fillFromData($(popup.el).find('.list'), data);

            var get_anti_users_name = function get_anti_users_name(anti_users) {
              return anti_users.map(function (id) {
                var emp = EmployeeList.empRows.find(function (e) {
                  return e.id == id;
                }) || {
                  name: '-'
                };
                return emp.name;
              });
            };

            if (data.anti_users !== null && data.anti_users !== '') $(popup.el).find('.anti_users').text(get_anti_users_name(data.anti_users.split(',')));else $(popup.el).find('.anti_users').text('');
            $(popup.el).find('.save-employee-button').click( /*#__PURE__*/function () {
              var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(e) {
                var data, rs;
                return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                  while (1) {
                    switch (_context4.prev = _context4.next) {
                      case 0:
                        data = Base.app.form.convertToData($(popup.el).find('.list'));
                        data.id = $row.data('row')['id']; //Remove autonumeric

                        data.salary = Utils.str2Num(data.salary);
                        _context4.next = 5;
                        return Base.api('Employee', 'update', data);

                      case 5:
                        rs = _context4.sent;
                        //Update lại dom
                        $row.find('.name').text(rs.row.name);
                        $row.find('.phone').text(rs.row.phone);
                        $row.data('row', rs.row);
                        Base.app.notification.create({
                          text: rs.message,
                          closeOnClick: true,
                          closeTimeout: 1500
                        }).open(); //Refresh lại danh sách nhân viên

                        _context4.next = 12;
                        return Employee.list()['rows'];

                      case 12:
                        Employee.rows = _context4.sent;
                        popup.close();

                      case 14:
                      case "end":
                        return _context4.stop();
                    }
                  }
                }, _callee4);
              }));

              return function (_x3) {
                return _ref4.apply(this, arguments);
              };
            }());
            $(popup.el).find('.choose-employee-button').click(function () {
              var content = "\n                <div style=\"height:400px; overflow: scroll\">\n                  ".concat(EmployeeList.empRows.filter(function (e) {
                return e.id !== data.id;
              }).map(function (e) {
                return "<div style=\"margin-bottom:10px; border-bottom: 1px solid #ccc; text-align: left;\"><input type=\"checkbox\" name=\"employee-item\" id=\"e_".concat(e.id, "\" value=\"").concat(e.id, "\" /> <label for=\"e_").concat(e.id, "\">").concat(e.name, "</label></div>");
              }).join(''), "\n                </div>\n              ");
              Base.app.dialog.create({
                title: 'Chọn nhân viên',
                content: content,
                on: {
                  open: function open(dialog) {
                    if (data.anti_users !== null && data.anti_users !== '') {
                      var anti_users = data.anti_users.split(',');
                      dialog.$el.find('input[type="checkbox"]').each(function () {
                        var _this = this;

                        data.anti_users.split(',').forEach(function (id) {
                          if ($(_this).val() == id) {
                            $(_this).prop('checked', true);
                            return;
                          }
                        });
                      });
                    }
                  }
                },
                buttons: [{
                  text: 'Huỷ'
                }, {
                  text: 'OK',
                  onClick: function () {
                    var _onClick = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(dialog) {
                      var anti_users, update_params;
                      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                        while (1) {
                          switch (_context5.prev = _context5.next) {
                            case 0:
                              anti_users = [], update_params = {};
                              dialog.$el.find('input[type="checkbox"]').each(function () {
                                if ($(this).prop('checked')) {
                                  var id = $(this).val();
                                  anti_users.push(id);
                                }
                              });

                              if (anti_users.length > 0) {
                                update_params = {
                                  id: data.id,
                                  anti_users: anti_users.join(',')
                                };
                                $(popup.el).find('.anti_users').text(get_anti_users_name(anti_users));
                              } else {
                                update_params = {
                                  id: data.id,
                                  anti_users: anti_users.join(',')
                                };
                                $(popup.el).find('.anti_users').text('');
                              }

                              _context5.next = 5;
                              return Base.call({
                                table: 'employee',
                                method: '_put',
                                params: update_params
                              });

                            case 5:
                            case "end":
                              return _context5.stop();
                          }
                        }
                      }, _callee5);
                    }));

                    function onClick(_x4) {
                      return _onClick.apply(this, arguments);
                    }

                    return onClick;
                  }()
                }]
              }).open();
            });
          }
        }
      }).open();
    });
    return $row;
  },
  list: function () {
    var _list = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
      var self, rs;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              self = this;
              _context6.next = 3;
              return Base.api('Employee', 'paging', {
                page: self.page,
                limit: self.limit
              });

            case 3:
              rs = _context6.sent;
              self.totalItems = rs.total;

              if (!(rs.rows.length == 0)) {
                _context6.next = 8;
                break;
              }

              $(self.pn + ' .infinite-scroll-preloader').addClass('display-none');
              return _context6.abrupt("return");

            case 8:
              self.empRows = rs.rows;
              self.currentDisplay += rs.rows.length;
              self.allowInfinite = true;
              rs.rows.forEach(function (item, i) {
                $(self.pn + ' .employee-list').append(self.appendRow(item));
              });
              if (self.currentDisplay == self.totalItems || self.currentDisplay > self.totalItems) $(self.pn + ' .infinite-scroll-preloader').addClass('display-none');else $(self.pn + ' .infinite-scroll-preloader').removeClass('display-none');

            case 13:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, this);
    }));

    function list() {
      return _list.apply(this, arguments);
    }

    return list;
  }()
};
export default (function ($prop, _ref5) {
  var $ = _ref5.$,
      $on = _ref5.$on;
  $on('pageInit', function () {
    EmployeeList.init();
  });

  var profile = function profile() {
    Base.profile();
  };

  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="page" data-name="employee">
    <div class="navbar">
      <div class="navbar-bg"></div>
      <div class="navbar-inner">
        <div class="left"><a href="#" data-panel=".panel-left" class="panel-open" id="menu-bars"><i class="f7-icons icon">bars</i></a></div>
        <div class="title sliding">Nhân viên 
          <a href="#" class="open-employee-form">
            <i class="icon f7-icons">plus</i>
          </a>
        </div>
        <div class="right"><a href="#" @click=${profile}><i class="f7-icons icon">person_circle</i></a></div>
      </div>
    </div>
    <div class="page-content infinite-scroll-content infinite-scroll-bottom">
      <div class="list links-list no-margin">
        <ul class="employee-list">

        </ul>
        <div class="preloader infinite-scroll-preloader"></div>
      </div>
    </div>

    <div id="employee-form-popup-wrapper">
    <div class="popup employee-form-popup">
      <div class="view">
        <div class="page">
          <div class="navbar">
            <div class="navbar-bg"></div>
            <div class="navbar-inner">
              <div class="title">Form nhân viên</div>
              <div class="right"><a class="link popup-close"><i class="f7-icons icon">multiply_square_fill</i></a></div>
            </div>
          </div>
          <div class="toolbar toolbar-bottom">
            <div class="toolbar-inner">
              <a href="#" class="link save-employee-button">Lưu lại</a>
              <a href="#" class="link reset-employee-password-button display-none">Reset mật khẩu</a>
            </div>
          </div>
          <div class="page-content">
            
            <div class="list no-margin">
              <ul>
                <li class="item-content item-input display-none">
                  <div class="item-inner">
                    <div class="item-title item-label">ID nhân viên</div>
                    <div class="item-input-wrap"><input type="text" readonly name="id" style="color: rgb(59, 59, 59);" /></div>
                  </div>
                </li>
                <li class="item-content item-input">
                  <div class="item-inner">
                    <div class="item-title item-label">Tên nhân viên</div>
                    <div class="item-input-wrap"><input type="text" name="name" /></div>
                  </div>
                </li>
                <li class="item-content item-input">
                  <div class="item-inner">
                    <div class="item-title item-label">Số điện thoại</div>
                    <div class="item-input-wrap"><input type="text" name="phone" /></div>
                  </div>
                </li>
                <li class="item-content item-input">
                  <div class="item-inner">
                    <div class="item-title item-label">Lương cứng</div>
                    <div class="item-input-wrap"><input type="text" name="salary" class="salary-autonumeric" /></div>
                  </div>
                </li>
                <li class="item-content item-input">
                  <div class="item-inner">
                    <div class="item-title item-label">Cần được đánh giá</div>
                    <div class="item-input-wrap input-dropdown-wrap">
                      <select name="is_reviewee">
                        <option value="0">Không</option>
                        <option value="1">Có</option>
                      </select>
                    </div>
                  </div>
                  <div class="item-inner">
                    <div class="item-title item-label">Là người đánh giá</div>
                    <div class="item-input-wrap input-dropdown-wrap">
                      <select name="is_reviewer">
                        <option value="0">Không</option>
                        <option value="1">Có</option>
                      </select>
                    </div>
                  </div>
                </li>
                
                <li class="item-content item-input">
                  <div class="item-inner">
                    <div class="item-title item-label">Trưởng cửa hàng</div>
                    <div class="item-input-wrap input-dropdown-wrap">
                      <select name="is_manager">
                        <option value="0">Không</option>
                        <option value="1">Có</option>
                      </select>
                    </div>
                  </div>
                  <div class="item-inner">
                    <div class="item-title item-label">Nhân viên ưu tú</div>
                    <div class="item-input-wrap input-dropdown-wrap">
                      <select name="is_nvut">
                        <option value="0">Không</option>
                        <option value="1">Có</option>
                      </select>
                    </div>
                  </div>
                </li>
                <li class="item-content item-input">
                  <div class="item-inner">
                    <div class="item-title item-label">Cơ sở mặc định (nếu là trưởng cửa hàng)</div>
                    <div class="item-input-wrap input-dropdown-wrap">
                      <select name="default_branch">
                        <option value="0">Không</option>
                        ${Base.initdata.branches_noshift.map(b=>$h`
                          <option value="${b.id}">${b.name}</option>
                        `)}
                      </select>
                    </div>
                  </div>
                </li>
                <li class="item-content item-input">
                  <div class="item-inner">
                    <div class="item-title item-label">Không thích làm cùng: <a class="choose-employee-button">Chọn nhân viên</a></div>
                    <div class="item-input-wrap anti_users">
                      
                    </div>
                  </div>
                </li>
                <!-- <li class="item-content item-input">
                  <div class="item-inner">
                    <div class="item-title item-label">Quỹ điểm hàng tháng</div>
                    <div class="item-input-wrap"><input type="text" name="default_point" /></div>
                  </div>
                </li> -->
              </ul>
            </div>

          </div>
        </div>
      </div>
    </div>
    </div>

  </div>
`
    }
    ;
});